import { render, staticRenderFns } from "./UpdateSchoolBrand.vue?vue&type=template&id=734a92e3&scoped=true"
import script from "./UpdateSchoolBrand.vue?vue&type=script&lang=js"
export * from "./UpdateSchoolBrand.vue?vue&type=script&lang=js"
import style0 from "./UpdateSchoolBrand.vue?vue&type=style&index=0&id=734a92e3&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "734a92e3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('734a92e3')) {
      api.createRecord('734a92e3', component.options)
    } else {
      api.reload('734a92e3', component.options)
    }
    module.hot.accept("./UpdateSchoolBrand.vue?vue&type=template&id=734a92e3&scoped=true", function () {
      api.rerender('734a92e3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/brandname/UpdateSchoolBrand.vue"
export default component.exports